module.exports = __webpack_public_path__ + "img/unchecked-icon.5cbf5db9.svg";